import 'babel-polyfill';
import 'whatwg-fetch';

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';

let conf = window.productAppConf;

Vue.use(BootstrapVue);

let app = new Vue({
    el: '#products-app',
    components: { App },
    render:
        h => h(App, {
            props: {
                conf: conf
            }
        })
})